module.exports = __webpack_public_path__ + "img/img2.52534aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/06/img2.png
// module id = 260
// module chunks = 0